import { SUBMIT_EULA_ASYNC } from './constants'

const initialState = {
  loader: false,
  message: null,
  status: null,
  error: null,
  success: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_EULA_ASYNC.INITIATE:
      return {
        ...state,
        loader: true,
        success: null,
        error: null,
      }
    case SUBMIT_EULA_ASYNC.ERROR:
      return {
        ...state,
        error: action.error,
        isValid: false,
        loader: false,
        success: false,
      }
    case SUBMIT_EULA_ASYNC.SUCCESS:
      return {
        ...state,
        loader: false,
        success: true,
      }
    default:
      return state
  }
}
